import { render, staticRenderFns } from "./BaseView.vue?vue&type=template&id=f664e716&"
import script from "./BaseView.vue?vue&type=script&lang=ts&"
export * from "./BaseView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports